export default "__VITE_ASSET__Mly9Ca64__"